import React /* , { useState } */ from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useForm } from 'react-hook-form';
// import { zodResolver } from '@hookform/resolvers/zod';
// import { z } from 'zod';
import { Card, /* CardContent, */ CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';
// import { Button } from '@/components/ui/Button';
// import { Input } from '@/components/ui/Input';
// import { Label } from '@/components/ui/Label';
// import { useAuth } from '@/contexts/AuthContext';
// import { RegisterFormData } from '@/types';

// const registerSchema = z.object({
//   nome: z.string().min(1, 'Nome é obrigatório'),
//   email: z.string().email('Email inválido').min(1, 'Email é obrigatório'),
//   senha: z.string().min(6, 'Senha deve ter pelo menos 6 caracteres'),
//   confirmarSenha: z.string(),
// }).refine((data) => data.senha === data.confirmarSenha, {
//   message: 'Senhas não coincidem',
//   path: ['confirmarSenha'],
// });

// type RegisterFormDataWithConfirm = RegisterFormData & {
//   confirmarSenha: string;
// };

export const RegisterPage: React.FC = () => {
  // const navigate = useNavigate();
  // const { register: registerUser, isLoading } = useAuth();
  // const [isSubmitting, setIsSubmitting] = useState(false);

  // const {
  //   register,
  //   handleSubmit,
  //   formState: { errors },
  // } = useForm<RegisterFormDataWithConfirm>({
  //   resolver: zodResolver(registerSchema),
  // });

  // const onSubmit = async (data: RegisterFormDataWithConfirm) => {
  //   try {
  //     setIsSubmitting(true);
  //     const { confirmarSenha, ...registerData } = data;
  //     await registerUser(registerData);
  //     navigate('/login');
  //   } catch (error) {
  //     // Error is handled by the auth context
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Sistema de Estágio
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            CODITECH - Crie sua conta
          </p>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Criar Conta</CardTitle>
            <CardDescription>
              {/* Preencha os dados para criar sua conta */}
              Nao esta disponivel no momento !
            </CardDescription>
          </CardHeader>
          {/* <CardContent>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
              <div>
                <Label htmlFor="nome">Nome Completo</Label>
                <Input
                  id="nome"
                  type="text"
                  placeholder="Seu nome completo"
                  {...register('nome')}
                  className={errors.nome ? 'border-error-500' : ''}
                />
                {errors.nome && (
                  <p className="mt-1 text-sm text-error-600">{errors.nome.message}</p>
                )}
              </div>

              <div>
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  {...register('email')}
                  className={errors.email ? 'border-error-500' : ''}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-error-600">{errors.email.message}</p>
                )}
              </div>

              <div>
                <Label htmlFor="senha">Senha</Label>
                <Input
                  id="senha"
                  type="password"
                  placeholder="Mínimo 6 caracteres"
                  {...register('senha')}
                  className={errors.senha ? 'border-error-500' : ''}
                />
                {errors.senha && (
                  <p className="mt-1 text-sm text-error-600">{errors.senha.message}</p>
                )}
              </div>

              <div>
                <Label htmlFor="confirmarSenha">Confirmar Senha</Label>
                <Input
                  id="confirmarSenha"
                  type="password"
                  placeholder="Confirme sua senha"
                  {...register('confirmarSenha')}
                  className={errors.confirmarSenha ? 'border-error-500' : ''}
                />
                {errors.confirmarSenha && (
                  <p className="mt-1 text-sm text-error-600">{errors.confirmarSenha.message}</p>
                )}
              </div>

              <Button
                type="submit"
                className="w-full"
                disabled={isSubmitting || isLoading}
              >
                {isSubmitting || isLoading ? 'Criando conta...' : 'Criar Conta'}
              </Button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-sm text-gray-600">
                Já tem uma conta?{' '}
                <Link
                  to="/login"
                  className="font-medium text-primary-600 hover:text-primary-500"
                >
                  Faça login aqui
                </Link>
              </p>
            </div>
          </CardContent> */}
        </Card>
      </div>
    </div>
  );
};
